import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { CompassLogo } from "@/components/CompassLogo";
import { useLang } from "@/i18n/LanguageContext";
import { UI, t } from "@/i18n/translations";
import { TERMS, PRIVACY } from "@/data/legal";

export function LegalContent({ doc }) {
  const { lang } = useLang();
  const data = doc === "privacy" ? PRIVACY : TERMS;
  return (
    <div className="space-y-5">
      <div>
        <h1 className="font-display text-3xl font-extrabold tracking-tight">{t(data.title, lang)}</h1>
        <p className="text-xs text-ink/40 mt-1">{t(data.updated, lang)}</p>
      </div>
      {data.sections.map((s, i) => (
        <div key={i} data-testid={`legal-section-${i}`}>
          <h2 className="font-display text-base font-bold mb-1.5">{t(s.h, lang)}</h2>
          <p className="text-sm text-ink/70 leading-relaxed">{t(s.p, lang)}</p>
        </div>
      ))}
    </div>
  );
}

export default function LegalPage() {
  const { lang, toggle } = useLang();
  const { doc } = useParams();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-paper text-ink">
      <header className="sticky top-0 z-30 backdrop-blur-xl bg-paper/80 border-b border-line">
        <div className="max-w-md mx-auto px-4 h-16 flex items-center justify-between">
          <button data-testid="legal-back-btn" onClick={() => navigate(-1)} className="flex items-center gap-1.5 font-semibold text-sm">
            <ChevronLeft className="w-5 h-5" /> {t(UI.legal.back, lang)}
          </button>
          <div className="flex items-center gap-2"><CompassLogo size={26} /><span className="font-display font-extrabold">Boussole</span></div>
          <button onClick={toggle} className="rounded-full border border-line bg-white px-3 py-1.5 text-sm font-bold">{lang.toUpperCase()}</button>
        </div>
      </header>
      <main className="max-w-md mx-auto px-4 py-6 pb-16"><LegalContent doc={doc} /></main>
    </div>
  );
}
